import React from "react";

function HotTopic() {
  return <div>HotTopic</div>;
}

export default HotTopic;
